import { render, staticRenderFns } from "./ReportULB.vue?vue&type=template&id=bef10b72&"
import script from "./ReportULB.vue?vue&type=script&lang=js&"
export * from "./ReportULB.vue?vue&type=script&lang=js&"
import style0 from "./ReportULB.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports